"use client";

import { useTranslations } from "next-intl";
import { LayoutGridIcon, ListIcon } from "lucide-react";

import type { AttachViewMode } from "@/components/admin/attach-picker/types";
import { Button } from "@/components/ui/button";
import { HoverTip } from "@/components/ui/tooltip";

export function AttachViewModeToggle({
  mode,
  disabled,
  onChange,
}: {
  mode: AttachViewMode;
  disabled?: boolean;
  onChange: (mode: AttachViewMode) => void;
}) {
  const t = useTranslations("site.attach");
  const nextMode = mode === "grid" ? "list" : "grid";
  const label = mode === "grid" ? t("listView") : t("gridView");

  return (
    <HoverTip content={label}><Button
      type="button"
      variant="ghost"
      size="icon-sm"
      disabled={disabled}
      aria-label={label}
      onClick={() => onChange(nextMode)}
    >
      {mode === "grid" ? (
        <ListIcon className="size-4" />
      ) : (
        <LayoutGridIcon className="size-4" />
      )}
    </Button></HoverTip>
  );
}
